import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import i18n from './i18n';
// import { GOOGLE_CLIENT_ID } from './api/config';
// import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}> */}
        {/* Preload Images */}
        <img
          src={`https://${process.env.REACT_APP_CDN_FQDN}/dcdial.com/v2/AccelerateGrowth.svg`}
          alt="Banner_img"
          className="w-full hidden"
        />
        <App />
      {/* </GoogleOAuthProvider> */}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
